/*
 * Die Rückfrage des Belegdesigners vor „Ablage übernehmen“ (Entscheid 687, Hausregel „Bestätigung vor
 * Datenänderung“). Die Folge steht so in api/src/routes/layouts.ts (R9: „Das Dokument der Engine wird Entwurf UND
 * Freigabestand“); den Satz zu ungespeicherten Eingaben und die Gefahr-Gestalt nur dann, wie bei „Layout neu laden“
 * (Rot-Regel: Kopf von `useBestaetigung` in @kundeninfo/ui).
 * Schlüssel englisch, Werte deutsch (Hausregel „Texte in Properties“).
 */
export const LAYOUT_TEXT = {
  adoptStoreTitle: "Ablage übernehmen?",
  adoptStoreText: (ungespeichert: boolean): string =>
    "Der Stand aus der Render-Engine wird Entwurf und Freigabestand dieses Layouts."
    + (ungespeichert ? " Ungespeicherte Eingaben gehen dabei verloren." : ""),
  adoptStore: "Übernehmen",
};

/*
 * Die Felder einer SEKTION (Register „Sektionen“ und Gruppe „Überschriften und Bezeichnungen“ im Register „Tabelle“,
 * Spec Überschriften mit Ebene, Migration 070). Welche Felder eine Sektion hat, sagt der Katalog.
 */
export const SECTION_TEXT = {
  hint: "Schriftgrösse in Punkt (6 bis 24) und Schnitt je Abschnitt des Belegs.",
  size: (label: string): string => `${label}: Größe`,
  weight: (label: string): string => `${label}: Schnitt`,
  style: (label: string): string => `${label}: Stil`,
  color: (label: string): string => `${label}: Farbe`,
  systemValue: (wert: string): string => `Systemwert (${wert})`,
  bold: "fett",
  normal: "normal",
  italic: "kursiv",
  upright: "aufrecht",
  systemColor: { akzent: "Akzentfarbe", text: "Textfarbe" },
  accentColor: "Akzentfarbe des Belegs",
  bar: "Akzentbalken am Hinweisblock",
  headingsGroup: "Überschriften und Bezeichnungen",
  headingsHint: "Schrift der Positionsüberschriften je Ebene und der Bezeichnung von Positionen und Textzeilen.",
} as const;
